import type { ReactNode } from "react";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Paper,
  SxProps,
  Theme,
} from "@mui/material";

type MenuItem = {
  label?: string;
  icon?: ReactNode;
  onClick?: () => void;
};

type CollapseMenuProps = {
  open: boolean;
  items?: MenuItem[];
  onClick?: () => void;
  onClose?: () => void;
  position?: SxProps<Theme>;
};

export default function CollapseMenu({
  open,
  items,
  position = { top: 60, right: 0 },
}: CollapseMenuProps) {
  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Paper
        sx={{
          position: "absolute",
          zIndex: 10,
          width: 200,
          bgcolor: "background.paper",
          boxShadow: 3,
          borderRadius: 1,
          ...position,
        }}
      >
        <List component="div" disablePadding>
          {items?.map((item, index) => (
            <ListItemButton
              key={index}
              onClick={item.onClick}
              sx={{
                borderBottom:
                  index !== items.length - 1 ? "1px solid #DFDDDD" : "none",
              }}
            >
              {item.icon && (
                <ListItemIcon sx={{ minWidth: 40, color: "text.secondary" }}>
                  {item.icon}
                </ListItemIcon>
              )}
              <ListItemText
                primary={item.label}
                slotProps={{
                  primary: { sx: { fontWeight: 500, color: "text.primary" } },
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </Paper>
    </Collapse>
  );
}
